import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { BaseGuard } from './base.guard';
import Enums from '../../shared/enum/enums';

@Injectable({
  providedIn: 'root',
})
export class ToolGuard extends BaseGuard {
  protected code: Enums.ToolCode;

  private tools = Enums.ToolCode;

  get tool() {
    return this.code;
  }

  constructor() {
    super();
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const rootTool = next.parent?.url[0]?.path as Enums.ToolCode;
    if (rootTool && Object.values(this.tools).includes(rootTool)) {
      this.code = rootTool;
      return true;
    } else return !!next.params.layer;
  }
}
